// Basic
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
// Store & actions
import useCustomizationStore from '@/app/store/modules/customization';
import useRootOrganizationStore from '@/app/store/rootOrganization';
import actionsCustomization from '../../api/actionsCustomization';
// Components
import DataTable from '@/common-utils/components/renders/dataTable/DataTable';
// Common
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import mergeQuery from '@/common-utils/components/renders/dataTable/utils/mergeQuery';
import { columnsCustomization, columnsCustomizationId } from './columnDef/columnsCustomization';

/**
 * @param root0
 * @param root0.pageActions
 * @param root0.filtersEventName
 * @returns {JSX} CustomizationTable
 */
function CustomizationTable({ pageActions = undefined, filtersEventName }) {

    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const { refetchCustomization: refetchFromStore, storeRefetchCustomization, query: queryStored, storeQuery } = useCustomizationStore();

    // Constants
    const initialQuery = getInitialQuery();

    // State
    const [query, setQuery] = useState(mergeQuery(initialQuery, queryStored));
    const [launchRefetch, setLaunchRefetch] = useState(true);

    // Api Calls
    const { contractAccessId: merchantAccountId } = useParams();
    const { data, isFetching, error, refetch } = actionsCustomization.getCustomizations({ query, merchantAccountId }, false);

    useEffect(() => {
        if (rootOrganization && (launchRefetch || refetchFromStore)) {
            refetch();
            setLaunchRefetch(false);
            storeRefetchCustomization(false);
        }
    }, [query, launchRefetch, refetchFromStore]);

    const allColumns = columnsCustomization({ query, setQuery, queryStored, storeQuery, setLaunchRefetch, merchantAccountId, filtersEventName });

    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isFetching}
            error={error}
            refetch={refetch}
            columnsId={columnsCustomizationId}
            initialQuery={initialQuery}
            query={query}
            setQuery={setQuery}
            queryStored={queryStored}
            storeQuery={storeQuery}
            setLaunchRefetch={setLaunchRefetch}

            pageActions={pageActions}
        />
    );
}

CustomizationTable.propTypes = {
    pageActions: PropTypes.node,
    filtersEventName: PropTypes.string
};

export default CustomizationTable;